import { render, staticRenderFns } from "./authorityManagement.vue?vue&type=template&id=6a15b2e6&scoped=true"
import script from "./authorityManagement.vue?vue&type=script&lang=js"
export * from "./authorityManagement.vue?vue&type=script&lang=js"
import style0 from "./authorityManagement.vue?vue&type=style&index=0&id=6a15b2e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a15b2e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a15b2e6')) {
      api.createRecord('6a15b2e6', component.options)
    } else {
      api.reload('6a15b2e6', component.options)
    }
    module.hot.accept("./authorityManagement.vue?vue&type=template&id=6a15b2e6&scoped=true", function () {
      api.rerender('6a15b2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/merbershipSystems/authorityManagement/authorityManagement.vue"
export default component.exports